import React, { SVGProps } from 'react';

export const ExportIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 20,
  height = 16,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 20 16"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 13.599H2V4.599H4.595C4.595 4.599 5.284 3.703 6.765 2.599H1C0.734784 2.599 0.48043 2.70436 0.292893 2.89189C0.105357 3.07943 0 3.33378 0 3.599L0 14.599C0 14.8642 0.105357 15.1186 0.292893 15.3061C0.48043 15.4936 0.734784 15.599 1 15.599H16C16.2652 15.599 16.5196 15.4936 16.7071 15.3061C16.8946 15.1186 17 14.8642 17 14.599V10.853L15 12.498V13.599ZM13.361 6.649V10.2L20 4.999L13.361 0V3.131C5.3 3.131 5.3 11.099 5.3 11.099C7.582 7.351 8.986 6.649 13.361 6.649Z"
        fill="#C6C6C6"
      />
    </svg>
  );
};
